import { getHomeScreenUrl } from '/src/features/login/api/login-service.js';

export default async (to) => {
  const route = to;
  const nuxtApp = useNuxtApp();
  const store = nuxtApp.$store;

  // Fetch platform theme details if not present already
  if (!store.state.platformTheme) {
    await store.dispatch('getThemeDetails');
  }

  // Include environment title in the browser tab name template when it's present and not set already
  const environmentTitle =
    store.getters.showFeatureUser('PLATFORM_TITLE', false) || store.state?.platformTheme?.platformTitle;
  if (environmentTitle && store?.state?.headTitleTemplate !== environmentTitle) {
    // Update the state to not update template for upcoming route changes
    store.commit('setHeadTitleTemplate', environmentTitle);
    // Set environment title into head title template when user is logged in and title is present
    useHead({
      titleTemplate: `%s | ${environmentTitle}`
    });
  }

  const mustGo = (await getHomeScreenUrl(store.getters.userDetails)) || '/launchpad';
  // Redirect to launchpad when the user changes the URL to login or forgot-password and is already logged in
  if (
    (route.path === '/' || /^(\/login|\/forgot-password|\/reset-password|\/verify-otp).*/gi.test(route.path)) &&
    store.state.forceLogout === 'Authorized' &&
    mustGo !== to.path
  ) {
    // return is required for redirection ignore sonar warning.
    return navigateTo(mustGo);
  }
};
